<template>
    <div>
        <b-card
            v-if="item.chief_type === 'physical'"
            no-body
            class="shadow-sm mb-3"
        >
            <b-card-body>
                <p class="mb-1 small font-weight-bold text-uppercase">
                    {{ item.chief_title }}
                </p>
                <physical-person-data
                    :data="item.chief_data"
                    :editable="canEdit"
                />

                <b-button variant="danger" size="sm" @click="confirmDelete">
                    <i class="fas fa-trash-alt fa-fw"></i> Supprimer ce
                    commissaire aux comptes
                </b-button>
            </b-card-body>
        </b-card>

        <b-card
            v-if="item.chief_type === 'moral'"
            no-body
            class="shadow-sm mb-3"
        >
            <b-card-body>
                <p class="mb-1 small font-weight-bold text-uppercase">
                    {{ item.chief_title }}
                </p>
                <moral-person-data :data="item.chief_data" />

                <b-button variant="danger" size="sm" @click="confirmDelete">
                    <i class="fas fa-trash-alt fa-fw"></i> Supprimer ce
                    commissaire aux comptes
                </b-button>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PhysicalPersonData from '../physicalPersons/PhysicalPersonData'
import MoralPersonData from '../moralPersons/MoralPersonData'

export default {
    name: 'Auditor',

    components: {
        MoralPersonData,
        PhysicalPersonData,
    },

    props: {
        item: null,
        canEdit: true,
    },

    methods: {
        confirmDelete() {
            this.$bvModal
                .msgBoxConfirm(
                    'Etes-vous sûr·e de vouloir supprimer ce commissaire aux comptes ?',
                    {
                        title: "Suppression d'un·e commissaire aux comptes",
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'OUI',
                        cancelTitle: 'NON',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then((value) => {
                    if (value) {
                        this.deleteAuditor()
                    }
                })
                .catch((err) => {
                    // An error occurred
                })
        },

        async deleteAuditor() {
            try {
                const response = await axios.delete(`/auditors/${this.item.id}`)
                this.$emit('auditor-is-deleted')
                this.$store.commit('legalVM/RESET_STATUS')
            } catch (error) {
                // handle error
                console.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
